/* global axios */
import ApiClient from './ApiClient';

class DraftsAPI extends ApiClient {
  constructor() {
    super('drafts', { accountScoped: true });
  }

  inConversation(displayId, conditions) {
    const filterParams = Object.fromEntries(
      Object.entries(conditions).filter(([k]) => Boolean(conditions[k]))
    );
    const queryParams = new URLSearchParams(filterParams).toString();
    return axios.get(`${this.url}/conversation/${displayId}?${queryParams}`);
  }

  getScheduled() {
    return axios.get(`${this.url}/scheduled`);
  }

  scheduleSend(draftId, { scheduledAt, timeZone }) {
    return axios.post(`${this.url}/${draftId}/schedule`, {
      scheduled_at: scheduledAt,
      timezone: timeZone,
    });
  }

  cancelScheduled(draftId) {
    return axios.delete(`${this.url}/${draftId}/schedule`);
  }

  attachFiles(draftId, files) {
    const formData = new FormData();
    files.forEach(file => {
      formData.append('files[]', file);
    });
    return axios.post(`${this.url}/${draftId}/attachments`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  }

  removeFile(draftId, fileId) {
    return axios.delete(`${this.url}/${draftId}/attachments/${fileId}`);
  }
}

export default new DraftsAPI();
